// Module
var code = "<template><div class=\"main-slot\"></div></template>";
// Exports
module.exports = code;